import requestAction from '../../utils/requestAction'

export const fetchComplaintTypes = () =>
  requestAction('COMPLAINT_TYPE_LIST')('complaintTypes', 'GET')
